import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type Stringified<T> = {
    [K in keyof T]: T[K] extends object
        ? Stringified<T[K]> // Recursively apply transformation
        : string;
};

export type DataOrError<Data, Error> = [Data, null] | [null, Error];

export const isHttpUnavailableStatusCodeError = (error: FetchBaseQueryError | SerializedError | undefined): boolean => {
    return !!(error && 'status' in error && error.status === 503);
};
